<template>
  <b-container id="partners">
    <div class="section section-partners">
      <h1>PARTENERI</h1>
      <img src="./../assets/mustata-only.png" alt class="logo-mustata" />
    </div>
    <div>
      <b-row cols="2" cols-md="2" cols-lg="4">
      
        <b-col class="d-flex align-items-center justify-content-center">
          <a href="https://viscri32.com/" target="_blank">
            <img :src="Viscri32" class="contact-partener" />
          </a>
        </b-col>

        <b-col class="d-flex align-items-center justify-content-center">
          <a href="https://www.rossmarkt.ro/" target="_blank">
            <img :src="Rossmarkt" class="contact-partener" />
          </a>
        </b-col>

        <b-col class="d-flex align-items-center justify-content-center">
          <a href="http://www.castelulbran.ro/" target="_blank">
            <img :src="Bran" class="contact-partener" />
          </a>
        </b-col>

        <!-- above done -->

        <b-col class="d-flex align-items-center justify-content-center">
          <a href="https://bistrodelarte.ro/" target="_blank">
            <img :src="Bistrodelarte" class="contact-partener" />
          </a>
        </b-col>

        <b-col class="d-flex align-items-center justify-content-center">
          <a href="https://www.hotelalpin.ro/" target="_blank">
            <img :src="Alpin" class="contact-partener" />
          </a>
        </b-col>

        <b-col class="d-flex align-items-center justify-content-center">
          <a href="http://crouton.ro/" target="_blank">
            <img :src="Crouton" class="contact-partener" />
          </a>
        </b-col>

        <b-col class="d-flex align-items-center justify-content-center">
          <a href="https://www.valeasalbatica.ro/" target="_blank">
            <img :src="Valea" class="contact-partener" />
          </a>
        </b-col>
        <!-- above done -->

        <b-col class="d-flex align-items-center justify-content-center">
          <a href="https://www.restaurantbelvedere.ro/" target="_blank">
            <img :src="Belvedere" class="contact-partener img-invert" />
          </a>
        </b-col>

        <b-col class="d-flex align-items-center justify-content-center">
          <a href="http://tipo-grafia.ro/" target="_blank">
            <img :src="Tipografia" class="contact-partener" />
          </a>
        </b-col>

        <b-col class="d-flex align-items-center justify-content-center">
          <a href="https://vilabran.ro/" target="_blank">
            <img :src="ClubVilaBran" class="contact-partener img-invert" />
          </a>
        </b-col>

        <b-col class="d-flex align-items-center justify-content-center">
          <a href="http://deanes-pub.ro/" target="_blank">
            <img :src="Deans" class="contact-partener img-invert" />
          </a>
        </b-col>
        <!-- above done -->

        <b-col class="d-flex align-items-center justify-content-center">
          <a href="https://www.gado.ro/" target="_blank">
            <img :src="Gado" class="contact-partener" />
          </a>
        </b-col>

        <b-col class="d-flex align-items-center justify-content-center">
          <a href="https://m.facebook.com/ogradadinbrasov/" target="_blank">
            <img :src="Ograda" class="contact-partener" />
          </a>
        </b-col>

        <b-col class="d-flex align-items-center justify-content-center">
          <a href="https://www.societegourmet.ro/" target="_blank">
            <img :src="Gourmet" class="contact-partener" />
          </a>
        </b-col>

        <b-col class="d-flex align-items-center justify-content-center">
          <a href="https://www.amfiteatrul.ro/" target="_blank">
            <img :src="Amfiteatru" class="contact-partener img-invert" />
          </a>
        </b-col>
        <!-- above done -->

        <b-col class="d-flex align-items-center justify-content-center">
          <a href="https://www.cuibuldelemn.ro/en/home/" target="_blank">
            <img :src="Cuibul" class="contact-partener img-invert" />
          </a>
        </b-col>

        <b-col class="d-flex align-items-center justify-content-center">
          <a href="https://moaraveche.com/" target="_blank">
            <img :src="moaraveche" class="contact-partener" />
          </a>
        </b-col>

        <b-col class="d-flex align-items-center justify-content-center">
          <a href="https://rombeerbrasov.ro/" target="_blank">
            <img :src="rombeer" class="contact-partener img-invert" />
          </a>
        </b-col>
        <!-- above done -->

        <b-col class="d-flex align-items-center justify-content-center">
          <a href="https://www.facebook.com/magnoliabrasov/" target="_blank">
            <img :src="Magnolia" class="contact-partener" />
          </a>
        </b-col>

        <b-col class="d-flex align-items-center justify-content-center">
          <a href="https://www.hotelambient.ro/ro/" target="_blank">
            <img :src="Ambient" class="contact-partener" />
          </a>
        </b-col>

        <b-col class="d-flex align-items-center justify-content-center">
          <a href="https://www.thebottle.ro/" target="_blank">
            <img :src="Bottle" class="contact-partener" />
          </a>
        </b-col>

        <b-col class="d-flex align-items-center justify-content-center">
          <a href="https://inghetata-brasov.ro/" target="_blank">
            <img :src="Eis" class="contact-partener" />
          </a>
        </b-col>
        <!-- above done -->

        <b-col class="d-flex align-items-center justify-content-center">
          <a href="https://www.facebook.com/schilthorn.ro/" target="_blank">
            <img :src="Schiltorn" class="contact-partener" />
          </a>
        </b-col>

        <b-col class="d-flex align-items-center justify-content-center">
          <a href="https://www.facebook.com/rockstadt/" target="_blank">
            <img :src="Rockstadt" class="contact-partener" />
          </a>
        </b-col>

        <b-col class="d-flex align-items-center justify-content-center">
          <a href="https://www.facebook.com/ShakeCoffeeBrasov/" target="_blank">
            <img :src="Shake" class="contact-partener" />
          </a>
        </b-col>

        <b-col class="d-flex align-items-center justify-content-center">
          <a href="https://www.facebook.com/bookcoffee.ro/" target="_blank">
            <img :src="Book" class="contact-partener" />
          </a>
        </b-col>
        <!-- above done -->

        <b-col class="d-flex align-items-center justify-content-center">
          <a href="https://www.facebook.com/welcometomassimobrasov/" target="_blank">
            <img :src="Massimo" class="contact-partener" />
          </a>
        </b-col>

        <b-col class="d-flex align-items-center justify-content-center">
          <a href="https://www.facebook.com/AlbertBistro" target="_blank">
            <img :src="Albert" class="contact-partener" />
          </a>
        </b-col>

        <b-col class="d-flex align-items-center justify-content-center">
          <a href="https://liquorstorebrasov.business.site/" target="_blank">
            <img :src="Liquorstore" class="contact-partener" />
          </a>
        </b-col>

        <b-col class="d-flex align-items-center justify-content-center">
          <a href="https://www.facebook.com/Electric-Bar-115523939894348/" target="_blank">
            <img :src="Electric" class="contact-partener" />
          </a>
        </b-col>
        <!-- above done -->

        <b-col class="d-flex align-items-center justify-content-center">
          <a href="https://www.facebook.com/lanoiacasa.bv/" target="_blank">
            <img :src="Lanoi" class="contact-partener" />
          </a>
        </b-col>

        <b-col class="d-flex align-items-center justify-content-center">
          <a href="https://www.facebook.com/KoronaBoutique/" target="_blank">
            <img :src="Korona" class="contact-partener" />
          </a>
        </b-col>

        <b-col class="d-flex align-items-center justify-content-center">
          <a href="https://www.facebook.com/aftarstube/" target="_blank">
            <img :src="Afterstube" class="contact-partener" />
          </a>
        </b-col>

        <b-col class="d-flex align-items-center justify-content-center">
          <a href="https://www.twinbeanscoffee.com/" target="_blank">
            <img :src="Twin" class="contact-partener" />
          </a>
        </b-col>
        <!-- above done -->

        <b-col class="d-flex align-items-center justify-content-center">
          <a
            href="https://www.facebook.com/WineandGiftBoutique/"
            target="_blank"
          >
            <img :src="Winegift" class="contact-partener" />
          </a>
        </b-col>

        <b-col class="d-flex align-items-center justify-content-center">
          <a href="https://www.facebook.com/muzz.bistro/" target="_blank">
            <img :src="Muzz" class="contact-partener" />
          </a>
        </b-col>

        <b-col class="d-flex align-items-center justify-content-center">
          <a href="https://www.facebook.com/thedenbrasov" target="_blank">
            <img :src="Thedenbarber" class="contact-partener" />
          </a>
        </b-col>
        <!-- above done -->

        <b-col class="d-flex align-items-center justify-content-center">
          <a href="https://www.facebook.com/NextDoorBrasov/" target="_blank">
            <img :src="Nextdoor" class="contact-partener" />
          </a>
        </b-col>

        <b-col class="d-flex align-items-center justify-content-center">
          <a href="https://www.pivnitabunicii.com/" target="_blank">
            <img :src="Pivnita" class="contact-partener" />
          </a>
        </b-col>

        <b-col class="d-flex align-items-center justify-content-center">
          <a href="https://www.berero.ro/" target="_blank">
            <img :src="Berero" class="contact-partener" />
          </a>
        </b-col>

        <b-col class="d-flex align-items-center justify-content-center">
          <a href="https://artizanbeer.ro/" target="_blank">
            <img :src="Artizan" class="contact-partener" />
          </a>
        </b-col>
        <!-- above done -->

        <b-col class="d-flex align-items-center justify-content-center">
          <a
            href="https://www.facebook.com/homecocktailbarbrasov/"
            target="_blank"
          >
            <img :src="Homecocktail" class="contact-partener" />
          </a>
        </b-col>

        <b-col class="d-flex align-items-center justify-content-center">
          <a
            href="https://www.facebook.com/Cafe-Central-Brasov-357310081144200/"
            target="_blank"
          >
            <img :src="Cafecentral" class="contact-partener" />
          </a>
        </b-col>

        <b-col class="d-flex align-items-center justify-content-center">
          <a href="https://laceaun.com/en/" target="_blank">
            <img :src="Ceaun" class="contact-partener" />
          </a>
        </b-col>
        <!-- above done -->

        <b-col class="d-flex align-items-center justify-content-center">
          <a href="https://urbanvillage.drachenhaus.ro/ro-ro" target="_blank">
            <img :src="Urban" class="contact-partener" />
          </a>
        </b-col>

        <b-col class="d-flex align-items-center justify-content-center">
          <a href="https://www.pastelchalet.ro/" target="_blank">
            <img :src="Pastel" class="contact-partener" />
          </a>
        </b-col>
        <!-- above done -->

        <b-col class="d-flex align-items-center justify-content-center">
          <a href="https://transylvanianinn.ro/" target="_blank">
            <img :src="Transylvania" class="contact-partener img-invert" />
          </a>
        </b-col>

        <b-col class="d-flex align-items-center justify-content-center">
          <a href="https://www.facebook.com/habitat.brasov/" target="_blank">
            <img :src="Habitat" class="contact-partener" />
          </a>
        </b-col>

        <b-col class="d-flex align-items-center justify-content-center">
          <a href="https://www.facebook.com/ecozenboutiquesibiu/" target="_blank">
            <img :src="Ecozen" class="contact-partener" />
          </a>
        </b-col>

        <b-col class="d-flex align-items-center justify-content-center">
          <a href="https://www.facebook.com/Deifrati/" target="_blank">
            <img :src="Deifrati" class="contact-partener" />
          </a>
        </b-col>
        <!-- above done -->

        <b-col class="d-flex align-items-center justify-content-center">
          <a href="http://pilvax.ro/" target="_blank">
            <img :src="Pilvax" class="contact-partener img-invert" />
          </a>
        </b-col>

        <b-col class="d-flex align-items-center justify-content-center">
          <a href="https://www.horacubrazi.ro/" target="_blank">
            <img :src="Hora" class="contact-partener" />
          </a>
        </b-col>

        <b-col class="d-flex align-items-center justify-content-center">
          <a href="https://www.facebook.com/opusnoua/" target="_blank">
            <img :src="Opus9" class="contact-partener" />
          </a>
        </b-col>

        <b-col class="d-flex align-items-center justify-content-center">
          <a href="https://www.mesendorfgasthaus.ro/" target="_blank">
            <img :src="Mesendorf" class="contact-partener" />
          </a>
        </b-col>

        <!-- above done -->

        <b-col class="d-flex align-items-center justify-content-center">
          <a href="https://sportmontan.ro/" target="_blank">
            <img :src="Sacele" class="contact-partener" />
          </a>
        </b-col>

        <b-col class="d-flex align-items-center justify-content-center">
          <a href="https://www.brasovmarathon.ro/" target="_blank">
            <img :src="Maraton" class="contact-partener img-invert" />
          </a>
        </b-col>

        <b-col class="d-flex align-items-center justify-content-center">
          <a href="http://keller-restaurant.ro/" target="_blank">
            <img :src="Keller" class="contact-partener img-invert" />
          </a>
        </b-col>

        <b-col class="d-flex align-items-center justify-content-center">
          <a href="https://carrefour.ro/corporate/magazine/brasov/carrefour-brasov" target="_blank">
            <img :src="Carrefour" class="contact-partener" />
          </a>
        </b-col>
        <!-- above done -->

        <b-col class="d-flex align-items-center justify-content-center">
          <a href="http://inimamuntelui.ro/" target="_blank">
            <img :src="inimaMuntelui" class="contact-partener" />
          </a>
        </b-col>

        <b-col class="d-flex align-items-center justify-content-center">
          <a href="https://www.maggiesranch.ro/" target="_blank">
            <img :src="Maggie" class="contact-partener" />
          </a>
        </b-col>

        <b-col class="d-flex align-items-center justify-content-center">
          <a href="https://www.facebook.com/frankiesbrasov/" target="_blank">
            <img :src="Frankies" class="contact-partener" />
          </a>
        </b-col>

        <b-col class="d-flex align-items-center justify-content-center">
          <a href="https://www.beauty-food.ro/" target="_blank">
            <img :src="Beautyfood" class="contact-partener img-invert" />
          </a>
        </b-col>
        <!-- above done -->

        <b-col class="d-flex align-items-center justify-content-center">
          <a href="https://radsor.ro/" target="_blank">
            <img :src="Radsor" class="contact-partener" />
          </a>
        </b-col>

        <b-col class="d-flex align-items-center justify-content-center">
          <a href="http://restaurantbranparc.ro/index.html" target="_blank">
            <img :src="Branparc" class="contact-partener" />
          </a>
        </b-col>

        <b-col class="d-flex align-items-center justify-content-center">
          <a href="https://www.resortambient.ro/" target="_blank">
            <img :src="AmbientResort" class="contact-partener" />
          </a>
        </b-col>

        <b-col class="d-flex align-items-center justify-content-center">
          <a href="https://www.vinoesapori.ro/en/home/" target="_blank">
            <img :src="Vinoesapori" class="contact-partener" />
          </a>
        </b-col>
        <!-- above done -->

        <b-col class="d-flex align-items-center justify-content-center">
          <a href="https://www.facebook.com/AmRosenanger/" target="_blank">
            <img :src="Amrosen" class="contact-partener" />
          </a>
        </b-col>

        <b-col class="d-flex align-items-center justify-content-center">
          <a href="https://www.facebook.com/DynastySanpetru" target="_blank">
            <img :src="dynasty" class="contact-partener" />
          </a>
        </b-col>

        <b-col class="d-flex align-items-center justify-content-center">
          <a href="https://www.facebook.com/GJCRomania/" target="_blank">
            <img :src="gloria" class="contact-partener" />
          </a>
        </b-col>

        <b-col class="d-flex align-items-center justify-content-center">
          <a href="https://www.facebook.com/BOULEVARDPUB/" target="_blank">
            <img :src="Boulevard" class="contact-partener" />
          </a>
        </b-col>
        <!-- above done -->

        <b-col class="d-flex align-items-center justify-content-center">
          <a href="https://www.facebook.com/casaberarilorartizanibrasov/" target="_blank">
            <img :src="casaberarilor" class="contact-partener" />
          </a>
        </b-col>

        <b-col class="d-flex align-items-center justify-content-center">
          <a href="https://www.facebook.com/BacaniaGRAMADOR/" target="_blank">
            <img :src="gramador" class="contact-partener" />
          </a>
        </b-col>

        <b-col class="d-flex align-items-center justify-content-center">
          <a href="https://www.facebook.com/Bistro-St-John-630811864014559/" target="_blank">
            <img :src="Bistrostjohn" class="contact-partener" />
          </a>
        </b-col>

        <b-col class="d-flex align-items-center justify-content-center">
          <a href="https://bacaniajanosbacsi.ro/" target="_blank">
            <img :src="Bacaniajanos" class="contact-partener" />
          </a>
        </b-col>

        <b-col class="d-flex align-items-center justify-content-center">
          <a href="https://www.facebook.com/wakebv" target="_blank">
            <img :src="Koa" class="contact-partener" />
          </a>
        </b-col>

        <b-col class="d-flex align-items-center justify-content-center">
          <a href="https://www.facebook.com/taqueriabv/" target="_blank">
            <img :src="Taqueria" class="contact-partener" />
          </a>
        </b-col>

        <b-col class="d-flex align-items-center justify-content-center">
          <a href="https://www.facebook.com/jamaica.pub.bar/" target="_blank">
            <img :src="Jamaicapub" class="contact-partener" />
          </a>
        </b-col>

        <b-col class="d-flex align-items-center justify-content-center">
          <a href="https://www.facebook.com/postavarul/" target="_blank">
            <img :src="postavarul" class="contact-partener" />
          </a>
        </b-col>

        <!-- new 04.04.2021 -->

        <b-col class="d-flex align-items-center justify-content-center">
          <a href="https://capizza.ro/" target="_blank">
            <img :src="capizza" class="contact-partener" />
          </a>
        </b-col>

        <b-col class="d-flex align-items-center justify-content-center">
          <a href="https://www.theliquorstore.ro/" target="_blank">
            <img :src="theliquorstore" class="contact-partener" />
          </a>
        </b-col>

        <b-col class="d-flex align-items-center justify-content-center">
          <a href="https://bacaniaveche.ro/" target="_blank">
            <img :src="bacaniaveche" class="contact-partener" />
          </a>
        </b-col>

        <b-col class="d-flex align-items-center justify-content-center">
          <a href="http://bacaniacompanion.ro/" target="_blank">
            <img :src="bacaniacompanion" class="contact-partener img-invert" />
          </a>
        </b-col>

        <b-col class="d-flex align-items-center justify-content-center">
          <a href="https://hanupaprika.ro/" target="_blank">
            <img :src="hanupaprika" class="contact-partener" />
          </a>
        </b-col>

        <b-col class="d-flex align-items-center justify-content-center">
          <a href="https://www.facebook.com/CarPath.InchirieriAutoRulote/" target="_blank">
            <img :src="carpath" class="contact-partener" />
          </a>
        </b-col>

        <b-col class="d-flex align-items-center justify-content-center">
          <a href="https://www.monklint.ro/" target="_blank">
            <img :src="monklint" class="contact-partener img-invert" />
          </a>
        </b-col>

        <b-col class="d-flex align-items-center justify-content-center">
          <a href="https://www.bacaniarod.ro/" target="_blank">
            <img :src="bacaniarod" class="contact-partener" />
          </a>
        </b-col>

        <b-col class="d-flex align-items-center justify-content-center">
          <a href="https://butchers.ro/" target="_blank">
            <img :src="butchers" class="contact-partener" />
          </a>
        </b-col>

        <b-col class="d-flex align-items-center justify-content-center">
          <a href="https://m.facebook.com/Pr%C4%83v%C4%83lia-cu-Licori-Brasov-100607508802073/" target="_blank">
            <img :src="pravalia" class="contact-partener" />
          </a>
        </b-col>

        <b-col class="d-flex align-items-center justify-content-center">
          <a href="https://www.facebook.com/kupaskischool/" target="_blank">
            <img :src="kupa" class="contact-partener" />
          </a>
        </b-col>

        <b-col class="d-flex align-items-center justify-content-center">
          <a href="https://www.facebook.com/junobrasov/" target="_blank">
            <img :src="juno" class="contact-partener" />
          </a>
        </b-col>

        <b-col class="d-flex align-items-center justify-content-center">
          <a href="https://www.facebook.com/kanzelpub" target="_blank">
            <img :src="kanzel" class="contact-partener" />
          </a>
        </b-col>

        <b-col class="d-flex align-items-center justify-content-center">
          <a href="https://www.facebook.com/visssualreal/" target="_blank">
            <img :src="visssual" class="contact-partener" />
          </a>
        </b-col>

        <b-col class="d-flex align-items-center justify-content-center">
          <a href="https://www.facebook.com/waycuproasterybrasov/" target="_blank">
            <img :src="waycup" class="contact-partener" />
          </a>
        </b-col>

        <b-col class="d-flex align-items-center justify-content-center">
          <a href="https://www.facebook.com/TheBoozersOffice/" target="_blank">
            <img :src="bar33" class="contact-partener" />
          </a>
        </b-col>

        <b-col class="d-flex align-items-center justify-content-center">
          <a href="https://www.facebook.com/homeofcoffee/" target="_blank">
            <img :src="meron" class="contact-partener" />
          </a>
        </b-col>

        <b-col class="d-flex align-items-center justify-content-center">
          <a href="https://www.facebook.com/kashmirbrasov/" target="_blank">
            <img :src="kashmir" class="contact-partener" />
          </a>
        </b-col>

        <b-col class="d-flex align-items-center justify-content-center">
          <a href="https://weplay.ro/?gclid=CjwKCAjwvuGJBhB1EiwACU1AibeWf4r2GT4rSv-Fg-Wugs93gerRkbcTv5AZ66aEmIdyhkKNYbBDxRoCgkMQAvD_BwE" target="_blank">
            <img :src="weplay" class="contact-partener" />
          </a>
        </b-col>

        <b-col class="d-flex align-items-center justify-content-center">
          <a href="https://www.facebook.com/tekafecoffeeshop/" target="_blank">
            <img :src="Tekafe" class="contact-partener" />
          </a>
        </b-col>

        <b-col class="d-flex align-items-center justify-content-center">
          <a href=" https://brasovjazz.ro/" target="_blank">
            <img :src="brasovJazz" class="contact-partener" />
          </a>
        </b-col>

        <b-col class="d-flex align-items-center justify-content-center">
          <a href="http://scularie-brasov.ro/#contact" target="_blank">
            <img :src="scularie" class="contact-partener" />
          </a>
        </b-col>

        <b-col class="d-flex align-items-center justify-content-center">
          <a href="https://velo-coffe-cafe-du-theatre.business.site/" target="_blank">
            <img :src="velo" class="contact-partener" />
          </a>
        </b-col>

        <b-col class="d-flex align-items-center justify-content-center">
          <a href="https://www.facebook.com/rb18coffee/" target="_blank">
            <img :src="rb18" class="contact-partener" />
          </a>
        </b-col>

        <b-col class="d-flex align-items-center justify-content-center">
          <a href="https://vizibil.eu/" target="_blank">
            <img :src="vizibil" class="contact-partener img-invert" />
          </a>
        </b-col>

        <b-col class="d-flex align-items-center justify-content-center">
          <a href="https://cafeteca.ro/" target="_blank">
            <img :src="cafeteca" class="contact-partener img-invert" />
          </a>
        </b-col>

        <b-col class="d-flex align-items-center justify-content-center">
          <a href="https://m.facebook.com/urban.cafe.bv/" target="_blank">
            <img :src="urbanCafe" class="contact-partener" />
          </a>
        </b-col>

        <b-col class="d-flex align-items-center justify-content-center">
          <a href="https://www.schusterhotel.ro/" target="_blank">
            <img :src="schuster" class="contact-partener" />
          </a>
        </b-col>

        <b-col class="d-flex align-items-center justify-content-center">
          <a href="https://www.butoiulvesel.ro/" target="_blank">
            <img :src="butoiulvesel" class="contact-partener" />
          </a>
        </b-col>

        <b-col class="d-flex align-items-center justify-content-center">
          <a href="https://coroana-brasovului.ro/english-bar/" target="_blank">
            <img :src="englishBar" class="contact-partener" />
          </a>
        </b-col>

        <b-col class="d-flex align-items-center justify-content-center">
          <a href="https://www.facebook.com/liricsocialclub/" target="_blank">
            <img :src="liric" class="contact-partener" />
          </a>
        </b-col>

        <!-- new -->
        <b-col class="d-flex align-items-center justify-content-center">
          <a
            href="https://www.facebook.com/bacaniafainabucuresti/"
            target="_blank"
          >
            <img :src="bacaniafaina" class="contact-partener" />
          </a>
        </b-col>
        <b-col class="d-flex align-items-center justify-content-center">
          <a href="https://www.bodegalamahala.ro/" target="_blank">
            <img :src="bodegamahala" class="contact-partener img-invert" />
          </a>
        </b-col>
        <b-col class="d-flex align-items-center justify-content-center">
          <a href="https://dash.ro/" target="_blank">
            <img :src="dash" class="contact-partener img-invert" />
          </a>
        </b-col>
        <b-col class="d-flex align-items-center justify-content-center">
          <a
            href="https://www.kasholounge.com/public/index.php"
            target="_blank"
          >
            <img :src="kasho" class="contact-partener" />
          </a>
        </b-col>
        <b-col class="d-flex align-items-center justify-content-center">
          <a href="http://www.kronwell.com/" target="_blank">
            <img :src="kronwell" class="contact-partener" />
          </a>
        </b-col>
        <b-col class="d-flex align-items-center justify-content-center">
          <a
            href="https://www.facebook.com/Papazaur-667060630094014/"
            target="_blank"
          >
            <img :src="papazaur" class="contact-partener" />
          </a>
        </b-col>
        <b-col class="d-flex align-items-center justify-content-center">
          <a href="https://qosmohotels.com/" target="_blank">
            <img :src="qosmo" class="contact-partener" />
          </a>
        </b-col>

        <b-col class="d-flex align-items-center justify-content-center">
          <a href="https://www.facebook.com/Kulinariakezdi/" target="_blank">
            <img :src="kulinaria" class="contact-partener" />
          </a>
        </b-col>
        <b-col class="d-flex align-items-center justify-content-center">
          <a href="https://www.facebook.com/OLD-HOUSE-110690254804909/" target="_blank">
            <img :src="oldhouse" class="contact-partener" />
          </a>
        </b-col>
        <b-col class="d-flex align-items-center justify-content-center">
          <a href="https://www.schwarzbistro.ro/" target="_blank">
            <img :src="schwarz" class="contact-partener" />
          </a>
        </b-col>
        <b-col class="d-flex align-items-center justify-content-center">
          <a href="https://www.facebook.com/kotyogokavezo/" target="_blank">
            <img :src="kotyo" class="contact-partener" />
          </a>
        </b-col>
        <b-col class="d-flex align-items-center justify-content-center">
          <a href="https://112coffee.com/" target="_blank">
            <img :src="coffee112" class="contact-partener" />
          </a>
        </b-col>
        <b-col class="d-flex align-items-center justify-content-center">
          <a href="https://www.facebook.com/vekkerkavekozosseg/" target="_blank">
            <img :src="vekker" class="contact-partener" />
          </a>
        </b-col>
        <b-col class="d-flex align-items-center justify-content-center">
          <a href="https://teomo.ro/" target="_blank">
            <img :src="teomo" class="contact-partener" />
          </a>
        </b-col>

        <b-col class="d-flex align-items-center justify-content-center">
          <a href="https://www.facebook.com/Harlequin-by-the-Sea-107657154908413/" target="_blank">
            <img :src="harlequinMamaia" class="contact-partener" />
          </a>
        </b-col>

        <b-col class="d-flex align-items-center justify-content-center">
          <a href="https://www.facebook.com/HarlequinMamaia/" target="_blank">
            <img :src="harlequin" class="contact-partener" />
          </a>
        </b-col>

        <b-col class="d-flex align-items-center justify-content-center">
          <a href="https://www.facebook.com/blueacquamamaialac/" target="_blank">
            <img :src="blueacquamamaia" class="contact-partener" />
          </a>
        </b-col>

        <b-col class="d-flex align-items-center justify-content-center">
          <a href="https://www.facebook.com/blueacquamamaia/" target="_blank">
            <img :src="blueacquamamaia" class="contact-partener" />
          </a>
        </b-col>

        <b-col class="d-flex align-items-center justify-content-center">
          <a href="https://www.facebook.com/RadissonBluAurumHotelBrasov" target="_blank">
            <img :src="raddisonblu" class="contact-partener" />
          </a>
        </b-col>
        
        <b-col class="d-flex align-items-center justify-content-center">
          <a href="https://subtampa.com/" target="_blank">
            <img :src="subtampa" class="contact-partener" />
          </a>
        </b-col>

        <b-col class="d-flex align-items-center justify-content-center">
          <div class="no-logo-partner">
            <a
              href="https://www.facebook.com/pages/News-Caffe/124375427669744"
              target="_blank"
            >
              News Cafe
            </a>
          </div>
        </b-col>
        <b-col class="d-flex align-items-center justify-content-center">
          <div class="no-logo-partner">
            <a
              href="https://www.facebook.com/pages/Galeria-Art-And-Coffe/465844976776066"
              target="_blank"
            >
              Galeria Art And Coffe
            </a>
          </div>
        </b-col>
      </b-row>
    </div>
  </b-container>
</template>

<script>
import ClubVilaBran from "./../assets/partners/clubvilabran.png";
import Albert from "./../assets/partners/albert.png";
import Alpin from "./../assets/partners/alpin.png";
import Artizan from "./../assets/partners/artizan.png";
import Belvedere from "./../assets/partners/belvedere.png";
import Berero from "./../assets/partners/berero.png";
import Bistrodelarte from "./../assets/partners/bistrodelarte.png";
import Bran from "./../assets/partners/bran.png";
import Cafecentral from "./../assets/partners/cafecentral.png";
import Deans from "./../assets/partners/deans.png";
import Ecozen from "./../assets/partners/ecozen.png";
import Fishforlife from "./../assets/partners/fishforlife.jpg";
import Keller from "./../assets/partners/keller.png";
import Liquorstore from "./../assets/partners/liquorstore.jpg";
import Schiltorn from "./../assets/partners/schiltorn.png";
import Tipografia from "./../assets/partners/tipografia.png";
import Tomita from "./../assets/partners/tomita.png";
import Viscri32 from "./../assets/partners/viscri32.png";
import Zenmarket from "./../assets/partners/zenmarket.png";
import Valea from "./../assets/partners/salbatica.png";
import Festival from "./../assets/partners/festival.png";
import Afterstube from "./../assets/partners/afterstube.jpg";
import Korona from "./../assets/partners/korona.jpg";
import Lanoi from "./../assets/partners/lanoiacasa.png";
import Twin from "./../assets/partners/twin.jpg";
import Pastel from "./../assets/partners/pastel.png";
import Maraton from "./../assets/partners/maraton.png";
import Sacele from "./../assets/partners/sacele.png";
import Crouton from "./../assets/partners/crouton.png";
import Gourmet from "./../assets/partners/gourmet.png";
import Bottle from "./../assets/partners/thebottle.png";
import Carrefour from "./../assets/partners/carrefour.png";
import Ceaun from "./../assets/partners/ceaun.png";
import Jurnal from "./../assets/partners/jurnal.png";
import Urban from "./../assets/partners/urbanvillage.png";
import Amrosen from "./../assets/partners/amrosen.jpg";
import Ninna from "./../assets/partners/ninna.png";
import Eis from "./../assets/partners/eis.png";
import Electric from "./../assets/partners/electric.jpg";
import Deifrati from "./../assets/partners/deifrati.jpeg";
import Hora from "./../assets/partners/hora.png";
import Magnolia from "./../assets/partners/magnolia-min.png";
import Rockstadt from "./../assets/partners/rockstadt.jpg";
import Shake from "./../assets/partners/shake.jpg";
import Koa from "./../assets/partners/koa.jpg";
import Massimo from "./../assets/partners/massimo.png";
import Taqueria from "./../assets/partners/taqueria.png";
import Ambient from "./../assets/partners/ambient.png";
import Pilvax from "./../assets/partners/pilvax.png";
import Book from "./../assets/partners/book.jpg";
import Ograda from "../assets/partners/ograda.png";
import Mesendorf from "../assets/partners/mesendorf.jpg";
import Pivnita from "../assets/partners/pivnita.png";
import Transylvania from "../assets/partners/transylvania.png";
import Gado from "../assets/partners/gado.png";
import AmbientResort from "../assets/partners/ambientresort.png";
import Blackandwhite from "../assets/partners/blackandwhite.jpg";
import Bistrostjohn from "../assets/partners/bistrostjohn.png";
import Frankies from "../assets/partners/frankies.jpg";
import Homecocktail from "../assets/partners/homecocktail.jpg";
import Jamaicapub from "../assets/partners/jamaicapub.jpg";
import Muzz from "../assets/partners/muzz.jpg";
import Nextdoor from "../assets/partners/nextdoor.jpg";
import Opus9 from "../assets/partners/opus9.jpg";
import Rossmarkt from "../assets/partners/rossmarkt.jpg";
import Tekafe from "../assets/partners/tekafe.jpg";
import Thedenbarber from "../assets/partners/denbarber.jpg";
import Vinoesapori from "../assets/partners/vinoesapori.jpg";
import Amfiteatru from "../assets/partners/amfiteatru.png";
import Branparc from "../assets/partners/branparc.jpg";
import Cuibul from "../assets/partners/cuibul.png";
import Maggie from "../assets/partners/maggie.jpg";
import Radsor from "../assets/partners/radsor.jpg";
import Simpla from "../assets/partners/_simpla.jpg";
import Bacaniajanos from "../assets/partners/bacaniajanos.jpg";
import Boulevard from "../assets/partners/boulevard.jpg";
import Beautyfood from "../assets/partners/beautyfood.png";
import Winegift from "../assets/partners/winegift.jpg";
import Habitat from "../assets/partners/habitat.jpg";
import casaberarilor from "../assets/partners/casaberarilor.jpg";
import dynasty from "../assets/partners/dynasty.jpg";
import gramador from "../assets/partners/gramador.jpg";
import gloria from "../assets/partners/gloria.jpg";
import postavarul from "../assets/partners/postavarul.jpg";
import butchers from "../assets/partners/butchers.png";
import moaraveche from "../assets/partners/moaraveche.jpeg";
import kupa from "../assets/partners/kupa.jpg";
import rombeer from "../assets/partners/rombeer.png";
import capizza from "../assets/partners/capizza.png";
import bacaniarod from "../assets/partners/bacaniarod.png";
import theliquorstore from "../assets/partners/theliquorstoreb.png";
import bacaniaveche from "../assets/partners/bacaniaveche.jpeg";
import bacaniacompanion from "../assets/partners/bacaniacompanion.png";
import butoiulvesel from "../assets/partners/butoiulvesel.png";
import hanupaprika from "../assets/partners/hanupaprika.png";
import carpath from "../assets/partners/carpath.png";
import kashmir from "../assets/partners/kashmir.jpg";
import brasovJazz from "../assets/partners/brasovjazz.png";
import englishBar from "../assets/partners/coroanabrasovului.jpg";
import juno from "../assets/partners/juno.png";
import kanzel from "../assets/partners/kanzel.png";
import liric from "../assets/partners/liric.jpg";
import scularie from "../assets/partners/scularie.png";
import monklint from "../assets/partners/monklint.png";
import pravalia from "../assets/partners/pravaliaculicori.png";
import visssual from "../assets/partners/vissual.jpg";
import weplay from "../assets/partners/weplay.png";
import waycup from "../assets/partners/waycup.jpg";
import velo from "../assets/partners/velo.png";
import rb18 from "../assets/partners/rb18.jpeg";
import vizibil from "../assets/partners/vizibil.png";
import cafeteca from "../assets/partners/cafeteca.png";
import urbanCafe from "../assets/partners/urbancafe.png";
import inimaMuntelui from "../assets/partners/inimamuntelui.png";
import bar33 from "../assets/partners/bar33.jpg";
import schuster from "../assets/partners/schuster.png";
import meron from "../assets/partners/meron.png";

import bacaniafaina from "./../assets/partners/bacaniafaina.jpg";
import bodegamahala from "./../assets/partners/bodegamahala.png";
import dash from "./../assets/partners/dash.png";
import kasho from "./../assets/partners/kasho.jpeg";
import kronwell from "./../assets/partners/kronwell.jpg";
import papazaur from "./../assets/partners/papazaur.jpeg";
import qosmo from "./../assets/partners/qosmo.jpg";
import coffee112 from "./../assets/partners/112.png"
import kotyo from "./../assets/partners/kotyo.jpg"
import kulinaria from "./../assets/partners/kuliaria.jpeg"
import oldhouse from "./../assets/partners/oldhouse.jpg"
import schwarz from "./../assets/partners/schwarz.jpg"
import teomo from "./../assets/partners/teomo.png"
import vekker from "./../assets/partners/vekker.jpg"

import harlequin from "./../assets/partners/harlequin.png"
import harlequinMamaia from "./../assets/partners/harlequinSea.jpg"
import blueacquamamaia from "./../assets/partners/blueaqua.jpg"

import raddisonblu from "./../assets/partners/raddisonblu.jpeg"
import subtampa from "./../assets/partners/subtampa.png"


export default {
  name: "Partners",

  computed: {
    harlequin() {
      return harlequin
    },
    harlequinMamaia() {
      return harlequinMamaia
    },
    blueacquamamaia() {
      return blueacquamamaia
    },
    Albert() {
      return Albert;
    },
    Alpin() {
      return Alpin;
    },
    Artizan() {
      return Artizan;
    },
    Belvedere() {
      return Belvedere;
    },
    Berero() {
      return Berero;
    },
    Bistrodelarte() {
      return Bistrodelarte;
    },
    Bran() {
      return Bran;
    },
    Cafecentral() {
      return Cafecentral;
    },
    ClubVilaBran() {
      return ClubVilaBran;
    },
    Deans() {
      return Deans;
    },
    Ecozen() {
      return Ecozen;
    },
    Fishforlife() {
      return Fishforlife;
    },
    Keller() {
      return Keller;
    },
    Liquorstore() {
      return Liquorstore;
    },
    Schiltorn() {
      return Schiltorn;
    },
    Tipografia() {
      return Tipografia;
    },
    Tomita() {
      return Tomita;
    },
    Viscri32() {
      return Viscri32;
    },
    Zenmarket() {
      return Zenmarket;
    },
    Valea() {
      return Valea;
    },
    Festival() {
      return Festival;
    },

    Afterstube() {
      return Afterstube;
    },
    Korona() {
      return Korona;
    },
    Lanoi() {
      return Lanoi;
    },
    Twin() {
      return Twin;
    },
    Pastel() {
      return Pastel;
    },
    Maraton() {
      return Maraton;
    },
    Sacele() {
      return Sacele;
    },
    Crouton() {
      return Crouton;
    },
    Gourmet() {
      return Gourmet;
    },
    Bottle() {
      return Bottle;
    },
    Carrefour() {
      return Carrefour;
    },
    Ceaun() {
      return Ceaun;
    },
    Jurnal() {
      return Jurnal;
    },
    Urban() {
      return Urban;
    },
    Amrosen() {
      return Amrosen;
    },
    Ninna() {
      return Ninna;
    },
    Eis() {
      return Eis;
    },
    Electric() {
      return Electric;
    },
    Deifrati() {
      return Deifrati;
    },
    Hora() {
      return Hora;
    },
    Magnolia() {
      return Magnolia;
    },
    Rockstadt() {
      return Rockstadt;
    },
    Shake() {
      return Shake;
    },
    Koa() {
      return Koa;
    },
    Massimo() {
      return Massimo;
    },
    Taqueria() {
      return Taqueria;
    },
    Ambient() {
      return Ambient;
    },
    Pilvax() {
      return Pilvax;
    },
    Book() {
      return Book;
    },
    Ograda() {
      return Ograda;
    },

    Mesendorf() {
      return Mesendorf;
    },
    Pivnita() {
      return Pivnita;
    },
    Transylvania() {
      return Transylvania;
    },
    Gado() {
      return Gado;
    },
    AmbientResort() {
      return AmbientResort;
    },
    Blackandwhite() {
      return Blackandwhite;
    },
    Bistrostjohn() {
      return Bistrostjohn;
    },
    Frankies() {
      return Frankies;
    },
    Homecocktail() {
      return Homecocktail;
    },
    Jamaicapub() {
      return Jamaicapub;
    },
    Muzz() {
      return Muzz;
    },
    Nextdoor() {
      return Nextdoor;
    },
    Opus9() {
      return Opus9;
    },
    Rossmarkt() {
      return Rossmarkt;
    },
    Tekafe() {
      return Tekafe;
    },
    Thedenbarber() {
      return Thedenbarber;
    },
    Vinoesapori() {
      return Vinoesapori;
    },
    Amfiteatru() {
      return Amfiteatru;
    },
    Branparc() {
      return Branparc;
    },
    Cuibul() {
      return Cuibul;
    },
    Maggie() {
      return Maggie;
    },
    Radsor() {
      return Radsor;
    },
    Simpla() {
      return Simpla;
    },
    Bacaniajanos() {
      return Bacaniajanos;
    },
    Boulevard() {
      return Boulevard;
    },
    Beautyfood() {
      return Beautyfood;
    },
    Winegift() {
      return Winegift;
    },
    Habitat() {
      return Habitat;
    },

    casaberarilor() {
      return casaberarilor;
    },
    dynasty() {
      return dynasty;
    },
    gramador() {
      return gramador;
    },
    gloria() {
      return gloria;
    },
    postavarul() {
      return postavarul;
    },

    butchers() {
      return butchers;
    },
    moaraveche() {
      return moaraveche;
    },
    kupa() {
      return kupa;
    },
    rombeer() {
      return rombeer;
    },
    capizza() {
      return capizza;
    },
    bacaniarod() {
      return bacaniarod;
    },
    theliquorstore() {
      return theliquorstore;
    },
    bacaniaveche() {
      return bacaniaveche;
    },
    bacaniacompanion() {
      return bacaniacompanion;
    },
    butoiulvesel() {
      return butoiulvesel;
    },
    hanupaprika() {
      return hanupaprika;
    },

    carpath() {
      return carpath;
    },

    kashmir() {
      return kashmir;
    },
    brasovJazz() {
      return brasovJazz;
    },
    englishBar() {
      return englishBar;
    },
    juno() {
      return juno;
    },
    kanzel() {
      return kanzel;
    },
    liric() {
      return liric;
    },
    scularie() {
      return scularie;
    },
    monklint() {
      return monklint;
    },
    pravalia() {
      return pravalia;
    },
    visssual() {
      return visssual;
    },
    weplay() {
      return weplay;
    },
    waycup() {
      return waycup;
    },
    velo() {
      return velo;
    },
    rb18() {
      return rb18;
    },
    vizibil() {
      return vizibil;
    },
    cafeteca() {
      return cafeteca;
    },
    urbanCafe() {
      return urbanCafe;
    },
    inimaMuntelui() {
      return inimaMuntelui;
    },
    bar33() {
      return bar33;
    },
    schuster() {
      return schuster;
    },
    meron() {
      return meron;
    },
    bacaniafaina() {
      return bacaniafaina;
    },
    bodegamahala() {
      return bodegamahala;
    },

    dash() {
      return dash;
    },
    kasho() {
      return kasho;
    },
    kronwell() {
      return kronwell;
    },
    papazaur() {
      return papazaur;
    },
    qosmo() {
      return qosmo;
    },
    coffee112() {
      return coffee112;
    },
    kulinaria() {
      return kulinaria;
    },
    oldhouse() {
      return oldhouse;
    },
    schwarz() {
      return schwarz;
    },
    kotyo() {
      return kotyo;
    },
    vekker() {
      return vekker;
    },
    teomo() {
      return teomo;
    },
    raddisonblu() {
      return raddisonblu;
    },
    subtampa() {
      return subtampa;
    },

  },
};
</script>

<style>
.text-center {
  text-align: center;
}

.contact-partener {
  max-width: 100%;
  max-height: 75px;
}

.img-invert {
  filter: invert(1);
}

.btn.btn-brown {
  color: #8b4e2e;
  border-color: #8b4e2e;
  background: white;
}

.btn.btn-brown:hover,
.btn.btn-brown:focus,
.btn.btn-brown:active,
.btn.btn-brown.active,
.btn.btn-brown:active:focus,
.open > .dropdown-toggle.btn.btn-brown {
  color: #8b4e2e;
  border-color: #8b4e2e;
  background: white;
  box-shadow: 0 0 0 0.1rem #8b4f2e8e;
}

.justify-content-center.col {
  padding: 30px;
}

div.card {
  border: none;
}

div.card-body {
  padding: 0;
}

.no-logo-partner {
  font-size: 14px;
  border: 1px solid grey;
  padding: 10px;
}

.no-logo-partner a {
  color: black;
}
</style>
